const useProd: boolean = true;

const appVersion: string = "1.6.3.201";

const serverUrlProd = "https://inform.internationalcybernetics.com";
const serverUrlDev = "http://localhost:5000";
// const serverUrlDev = "http://192.168.1.126:5000";

const serverUrl = useProd ? serverUrlProd : serverUrlDev;

const appSettings = {
  useProd,
  serverUrl,
  appVersion,
};

export default appSettings;
